module.exports = "/assets/data/5fafc4d74f42af9560b19c65ce165f71-ZE1.data.json";